<template>
    <div class="md:container flex flex-col">
        <Breadcrumbs
            :breadcrumbs="breadcrumbs"
            class="max-md:container"
        />

        <CourseShowHeader />

        <div class="flex">
            <TabsPanel
                model-value="documents"
                panel-list-class="mb-4 md:mb-6"
                class="min-w-0"
            >
                <TabsPanelTab
                    id="documents"
                    :name="t('document_other')"
                    :component="tabs.CourseShowDocuments"
                ></TabsPanelTab>

                <TabsPanelTab
                    id="discussion"
                    :name="t('discussion')"
                    :component="tabs.CourseShowDiscussion"
                ></TabsPanelTab>

                <TabsPanelTab
                    id="flashcards"
                    :name="t('flashcard_other')"
                    :component="tabs.CourseShowFlashcards"
                ></TabsPanelTab>
            </TabsPanel>

            <TheRightSidebar
                v-if="isLoggedIn"
                top-spacing
            >
                <transition name="fade">
                    <ExamWidget
                        v-if="!course?.grade && course.showExamWidget && !examDateSubmitted"
                        class="mb-3"
                        @success="examDateSubmitted = true"
                    ></ExamWidget>
                </transition>
            </TheRightSidebar>
        </div>
    </div>
</template>

<script>
import TabsPanel, { lazyLoadTab } from '@components/TabsPanel';
import TabsPanelTab from '@components/TabsPanelTab';
import Breadcrumbs from '@components/Breadcrumbs';
import ExamWidget from '@components/ExamWidget';
import TheRightSidebar from '@components/TheRightSidebar';
import { mapGetters } from 'vuex';
import { getCourseLink, getUniLink } from '@/router/links';
import { useTranslation } from 'i18next-vue';
import CourseShowHeader from './CourseShowHeader.vue';

export default {
    name: 'CourseShow',
    components: {
        ExamWidget,
        CourseShowHeader,
        TabsPanel,
        TabsPanelTab,
        Breadcrumbs,
        TheRightSidebar,
    },
    setup() {
        const { t } = useTranslation('course');
        return { t };
    },
    data() {
        return {
            course: window.sdWindow.course,
            examDateSubmitted: false,
        };
    },
    computed: {
        ...mapGetters('auth', ['isLoggedIn']),
        ...mapGetters({ userCourses: 'user/courses' }),
        ...mapGetters('ui', ['screenSize']),
        breadcrumbs() {
            return [
                {
                    title: this.course.university.name,
                    link: getUniLink(this.course.university.id, this.course.university.name),
                },
                {
                    title: this.t('breadcrumbs.courseName', { course: this.course.name }),
                    link: getCourseLink(this.course.id, this.course.name),
                },
            ];
        },
        tabs() {
            return {
                CourseShowDiscussion: lazyLoadTab(() => import('./CourseShowDiscussion.vue')),
                CourseShowDocuments: lazyLoadTab(() => import('./CourseShowDocuments.vue')),
                CourseShowFlashcards: lazyLoadTab(() => import('./CourseShowFlashcards.vue')),
            };
        },
    },
    created() {
        this.$store.dispatch('course/setCourseData', this.course);

        if (!this.isLoggedIn) {
            this.$store.dispatch('university/setCurrentUniversity', this.course.university);
        }
    },
};
</script>
